<template>
    <div class="md:flex md:items-center mb-6">
      <label>Project type</label>
      <select v-model="type" class="bg-gray-200 appearance-none border-2 border-gray-200 rounded w-full py-2 px-4 text-gray-700 leading-tight focus:outline-none">
        <option value="" disabled selected hidden>Please select</option>
        <option value="gatsby">
          Gatsby
        </option>
        <option value="gridsome">
        Gridsome
        </option>
        <option value="other">
          Other
        </option>
      </select>
      <Button @click="$emit('next')">Next</Button>

    </div>
</template>

<script>
import Button from '@/components/shared/Button.vue'

export default {
  name: 'ProjectType',
  components: {
    Button
  },
  data () {
    return {
      type: ''
    }
  }
}
</script>

<style>

</style>
